<template>
    <DashView>
        <div class="container-fluid pt-4 px-4 pb-5 mb-5">
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="container py-4" v-if="profile_user">
                                <div class="row">
                                    <!-- Colonne principale -->
                                    <div class="col-lg-8">
                                        <div class="profile-header p-4 mb-4">
                                            <div class="row align-items-center">
                                                <div class="col-md-3 text-center">
                                                    <img src="https://i.pravatar.cc/150?img=6" alt="Photo de profil" class="profile-img rounded-circle mb-3">
                                                </div>
                                                <div class="col-md-9">
                                                    <h2 class="mb-1">{{profile_user.role }} {{profile_user.nom}} {{ profile_user.prenom }}</h2>
                                                    <p class="text-muted mb-2" v-if="Array.isArray(profile_user.specialites) && profile_user.specialites.length">{{ profile_user.specialites.join(' - ') }}</p>
                                                    <p v-else>Aucune spécialité</p>
                                                    <div class="d-flex align-items-center mb-3">
                                                        <span class="badge status-badge me-2" style="background-color: #00C853;">Actif</span>
                                                        <small class="text-muted">Temps plein</small>
                                                    </div>
                                                    <div class="d-flex flex-wrap">
                                                        <button class="btn btn-outline-emerald me-2 mb-2">
                                                            <i class="bi bi-pencil-square me-1"></i> Modifier
                                                        </button>
                                                        <button class="btn btn-outline-emerald me-2 mb-2">
                                                            <i class="bi bi-printer me-1"></i> Imprimer
                                                        </button>
                                                        <button class="btn btn-outline-emerald mb-2">
                                                            <i class="bi bi-file-earmark-text me-1"></i> Dossiers
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Détails du profil -->
                                        <div class="profile-details p-4 mb-4">
                                            <h4 class="mb-4"><i class="bi bi-info-circle me-2"></i>Informations personnelles</h4>
                                            
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <ul class="list-group list-group-flush">
                                                        <li class="list-group-item d-flex justify-content-between align-items-center">
                                                            <span><i class="bi bi-envelope me-2" style="color: #00C853;"></i></span>
                                                            <span class="text-muted">{{ profile_user.mail }}</span>
                                                        </li>
                                                        <li class="list-group-item d-flex justify-content-between align-items-center">
                                                            <span><i class="bi bi-person me-2" style="color: #00C853;"></i>Sexe</span>
                                                            <span class="text-muted">{{ profile_user.sexe_label }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="col-md-6">
                                                    <ul class="list-group list-group-flush">
                                                        <li class="list-group-item d-flex justify-content-between align-items-center">
                                                            <span><i class="bi bi-geo-alt me-2" style="color: #00C853;"></i>Adresse</span>
                                                            <span class="text-muted">Petion-Ville, Haiti</span>
                                                        </li>
                                                        <li class="list-group-item d-flex justify-content-between align-items-center">
                                                            <span><i class="bi bi-telephone me-2" style="color: #00C853;"></i>Téléphone</span>
                                                            <span class="text-muted">{{ profile_user.telephone }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Informations professionnelles -->
                                        <div class="profile-details p-4">
                                            <h4 class="mb-4"><i class="bi bi-briefcase me-2"></i>Informations professionnelles</h4>
                                            
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <ul class="list-group list-group-flush">
                                                        <li class="list-group-item d-flex justify-content-between align-items-center">
                                                            <span><i class="bi bi-person-badge me-2" style="color: #00C853;"></i>ID Employé</span>
                                                            <span class="text-muted">{{ profile_user.id }}</span>
                                                        </li>
                                                        <!-- <li class="list-group-item d-flex justify-content-between align-items-center">
                                                            <span><i class="bi bi-calendar-date me-2" style="color: #00C853;"></i>Date d'embauche</span>
                                                            <span class="text-muted">{{ profile_user.created }}</span>
                                                        </li> -->
                                                    </ul>
                                                </div>
                                                <div class="col-md-6">
                                                    <ul class="list-group list-group-flush">
                                                        <li class="list-group-item d-flex justify-content-between align-items-center">
                                                            <span><i class="bi bi-calendar-date me-2" style="color: #00C853;"></i>Date d'embauche</span>
                                                            <span class="text-muted">{{ profile_user.created }}</span>
                                                        </li>
                                                        <!-- <li class="list-group-item d-flex justify-content-between align-items-center">
                                                            <span><i class="bi bi-clock me-2" style="color: #00C853;"></i>Statut emploi</span>
                                                            <span class="text-muted">Temps plein (35h/semaine)</span>
                                                        </li> -->
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Colonne latérale -->
                                    <div class="col-lg-4">
                                        <div class="card mb-4">
                                            <div class="card-header text-white" style="background-color: #00C853;">
                                                <i class="bi bi-bell-fill me-2"></i>Alertes
                                            </div>
                                            <div class="card-body">
                                                <div class="alert-card p-3 mb-3 rounded">
                                                    <h6><i class="bi bi-calendar-check me-2" style="color: #00C853;"></i>Rendez-vous à venir</h6>
                                                    <p class="mb-0">3 consultations programmées aujourd'hui</p>
                                                </div>
                                                <div class="alert-card p-3 mb-3 rounded">
                                                    <h6><i class="bi bi-file-richtext me-2" style="color: #00C853;"></i>Certifications</h6>
                                                    <p class="mb-0">1 certification à renouveler dans 15 jours</p>
                                                </div>
                                                <div class="alert-card p-3 rounded">
                                                    <h6><i class="bi bi-graph-up me-2" style="color: #00C853;"></i>Heures travaillées</h6>
                                                    <p class="mb-0">128 heures ce mois-ci</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card">
                                            <div class="card-header text-white" style="background-color: #00C853;">
                                                <i class="bi bi-speedometer2 me-2"></i>Statistiques
                                            </div>
                                            <div class="card-body">
                                                <div class="d-flex justify-content-between mb-3">
                                                    <div class="text-center">
                                                        <div class="fs-4" style="color: #00C853;">24</div>
                                                        <small class="text-muted">Patients cette semaine</small>
                                                    </div>
                                                    <div class="text-center">
                                                        <div class="fs-4" style="color: #00C853;">3.5</div>
                                                        <small class="text-muted">Moyenne/5 étoiles</small>
                                                    </div>
                                                    <div class="text-center">
                                                        <div class="fs-4" style="color: #00C853;">98%</div>
                                                        <small class="text-muted">Assiduité</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </DashView>
</template>
<script>
import DashView from "@/components/DashView.vue"
import axios from 'axios'
  import $ from 'jquery';
  const base_url=process.env.VUE_APP_API_URL;
export default {
    name:"ProfileEmploye",
    components:{
        DashView
    },
    data(){
      return{
          profile_user:[],
          info_assurance:[],
          success_msg:'',
          validationErrors:[],
          accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
          selectRendezVous:[]
      }
    },
    created(){
        axios.get(`${base_url}/profileUser`,{
                    headers:{
                            Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
              .then((response)=>{
                  console.log(response.data.profile);
                  if(response.data.profile){
                      this.profile_user = response.data.profile;
                  }
                  
                  
              })
              .catch((error)=>{
                console.log(error?.response?.status);
                if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#openModalNoAccess').trigger('click');
                }
                else {
                // Gérer d'autres erreurs ici
                console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
                }
              });
    },
    methods:{
        formatDate(dateString) {
            if (!dateString) {
                // Si dateString est undefined ou null, retourner une chaîne vide
                return ''; 
            }
            const [year, month, day] = dateString.split('-');
            return `${day}-${month}-${year}`;
        },
        redirectTo(path) {
            this.$router.push(path);
            setTimeout(function() {
            location.reload();
            }, 1);
        },

    }
}
</script>
<style scoped>
    .btn-outline-emerald {
        color: #00C853;
        border: 1px solid #00C853;
        background-color: transparent;
        transition: all 0.3s ease;
    }

    .btn-outline-emerald:hover {
        background-color: #00C853;
        color: white;
    }

</style>